/**
 * The size (in bytes) of each data chunk used during compression operations.
 *
 * @remarks
 * This constant defines the chunk size as 512 kilobytes (512 * 1024 bytes).
 * It is used to split large data streams into manageable pieces for efficient
 * compression and decompression.
 */
export const CHUNK_SIZE = 512 * 1024; // 512 KB
